import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import { onMounted, computed, reactive, onBeforeUnmount, watch, ref, nextTick } from "vue";
export default {
  props: ["questionInfo", "menu", "allAnswers"],
  setup(props, content) {
    let movingItem = reactive({
      text: "",
      id: "",
      isShow: true,
      top: 0,
      left: 0
    });
    //答案
    let answer = computed(() => {
      if (props.allAnswers && props.allAnswers[props.questionInfo.questionGroupList[0].questionList[0].questionId]) {
        return props.allAnswers[props.questionInfo.questionGroupList[0].questionList[0].questionId];
      } else if (props.allAnswers[props.questionInfo.questionGroupList[0].questionList[0].questionId] === "") {
        return "";
      } else {
        let list = props.questionInfo.questionGroupList[0].questionList[0].questionPrompt.split("#");
        let answer = [];
        for (let i = 0; i < list.length; i++) {
          answer.push(i + 1);
        }
        return answer.join(",");
      }
    });
    let answerList = computed(() => {
      let anList = [];
      let list = answer.value.split(",");
      list.forEach(item => {
        questionItem.value.some(qItem => {
          if (qItem.id == item) {
            anList.push(qItem);
            return true;
          }
        });
      });
      return anList;
    });
    let isMountedOver = ref(false);
    //距离
    let distance = reactive([0]);
    onMounted(() => {
      isMountedOver.value = true;
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      isMountedOver.value = false;
      document.getElementsByClassName("question")[0].scrollTop = 0;
      distance.splice(0, distance.length);
      distance.push(0);
      setTimeout(() => {
        isMountedOver.value = true;
      }, 50);
    });
    //处理题目
    let itemText = computed(() => {
      let text = props.questionInfo.itemText;
      let questionNum = `<span style="background: #4bbbff;color:#fff;display:inline;border-radius:5px;min-width: 16px;height:15px;text-align:center;line-height:15px;padding: 2px 6px;font-size:14px">${props.questionInfo.menu}</span>`;
      let questionBox = "<span class='questionBoxT'></span>";
      if (text.indexOf("{{") != -1) {
        text = text.substring(0, text.indexOf("{{")) + questionNum + questionBox + text.substr(text.indexOf("}}") + 2);
      } else if (text.indexOf("<u>") != -1) {
        text = text.substring(0, text.indexOf("<u>")) + questionNum + questionBox + text.substr(text.lastIndexOf("</u>") + 4);
      } else {
        text = text.substring(0, text.indexOf("__")) + questionNum + questionBox + text.substr(text.lastIndexOf("__") + 2);
      }
      return text;
    });
    //答案项
    let questionItem = computed(() => {
      let questList = [];
      let list = props.questionInfo.questionGroupList[0].questionList[0].questionPrompt.split("#");
      for (let i = 0; i < list.length; i++) {
        if (answer.value && answer.value.indexOf(i - 0 + 1) != -1) {
          questList.push({
            text: list[i],
            id: i + 1,
            isShow: false
          });
        } else {
          questList.push({
            text: list[i],
            id: i + 1,
            isShow: true
          });
        }
      }
      return questList;
    });
    let {
      setQuestionFromAnswer,
      preview,
      positionIndex,
      setQuestion,
      overQuestion,
      moveQuestion
    } = useDragAnswer(movingItem, questionItem, setAnswer, distance, answerList);
    function setAnswer(list) {
      let answerText = "";
      //删选位置
      for (let i = 0; i < list.length; i++) {
        answerText += list[i].id + ",";
      }
      let data = {};
      data[props.questionInfo.questionGroupList[0].questionList[0].questionId] = answerText.slice(0, -1);
      content.emit("setAnswer", data);
    }
    return {
      distance,
      setQuestionFromAnswer,
      preview,
      positionIndex,
      isMountedOver,
      answerList,
      itemText,
      questionItem,
      setQuestion,
      movingItem,
      overQuestion,
      moveQuestion
    };
  }
};
function useDragAnswer(movingItem, questionItem, setAnswer, distance, answerList) {
  onMounted(() => {
    window.addEventListener("mouseup", overQuestion);
    window.addEventListener("touchend", overQuestion);
  });
  onBeforeUnmount(() => {
    window.removeEventListener("mouseup", overQuestion);
    window.removeEventListener("touchend", overQuestion);
  });
  let positionIndex = ref(-1);

  //点击 触摸开始 记录单词数据
  function setQuestion(e, msg) {
    let x = e.clientX || e.targetTouches[0].clientX;
    let y = e.clientY || e.targetTouches[0].clientY;
    msg.isShow = false;
    movingItem.left = x - document.getElementById("pwco").offsetLeft - document.getElementById("pwco").offsetParent.offsetLeft - document.getElementById("pwcoMove").offsetWidth / 2;
    movingItem.top = y - document.getElementById("pwco").offsetTop - document.getElementById("pwco").offsetParent.offsetTop - document.getElementById("pwcoMove").offsetHeight / 2;
    for (let key in msg) {
      movingItem[key] = msg[key];
    }
  }
  //移动计算拖拽
  function moveQuestion(e) {
    if (!movingItem.isShow) {
      let x = e.clientX || e.targetTouches[0].clientX;
      let y = e.clientY || e.targetTouches[0].clientY;
      movingItem.left = x - document.getElementById("pwco").offsetLeft - document.getElementById("pwco").offsetParent.offsetLeft - document.getElementById("pwcoMove").offsetWidth / 2;
      movingItem.top = y - document.getElementById("pwco").offsetTop - document.getElementById("pwco").offsetParent.offsetTop - document.getElementById("pwcoMove").offsetHeight / 2;
      preview(e);
    }
  }
  function setQuestionFromAnswer(e, msg) {
    let x = e.clientX || e.targetTouches[0].clientX;
    let y = e.clientY || e.targetTouches[0].clientY;
    msg.isShow = false;
    movingItem.left = x - document.getElementById("pwco").offsetLeft - document.getElementById("pwco").offsetParent.offsetLeft - document.getElementById("pwcoMove").offsetWidth / 2;
    movingItem.top = y - document.getElementById("pwco").offsetTop - document.getElementById("pwco").offsetParent.offsetTop - document.getElementById("pwcoMove").offsetHeight / 2;
    for (let key in msg) {
      movingItem[key] = msg[key];
    }
  }
  function overQuestion() {
    if (movingItem.isShow) return 0;
    movingItem.isShow = true;
    // 放入
    if (positionIndex.value >= 0 && distance[positionIndex.value] <= 2500) {
      let list = [...answerList.value];
      list.splice(positionIndex.value, 0, {
        ...movingItem
      });
      list.some((item, index) => {
        if (item.id == movingItem.id && index != positionIndex.value) {
          list.splice(index, 1);
          return true;
        }
      });
      setAnswer(list);
    } //拿出
    // else {
    //   questionItem.value.some((item) => {
    //     if (item.id == movingItem.id) {
    //       item.isShow = true;
    //       return true;
    //     }
    //   });
    //   answerList.value.some((item, index) => {
    //     if (item.id == movingItem.id) {
    //       let list = [...answerList.value];
    //       list.splice(index, 1);
    //       setAnswer(list);
    //       return true;
    //     }
    //   });
    // }

    movingItem.id = null;
    positionIndex.value = -1;
  }

  //预览插入
  function preview(e) {
    if (movingItem.isShow) return 0;
    nextTick(() => {
      let domlist = document.getElementsByClassName("questionPreview");
      let x = e.clientX || e.targetTouches[0].clientX;
      let y = e.clientY || e.targetTouches[0].clientY;
      distance.splice(0, distance.length);
      positionIndex.value = 0;
      for (let i = 0; i < domlist.length; i++) {
        let x1 = domlist[i].getBoundingClientRect().x;
        let y1 = domlist[i].getBoundingClientRect().y;
        distance[i] = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
        if (distance[i] < distance[positionIndex.value]) positionIndex.value = i;
      }
    });
  }
  return {
    setQuestionFromAnswer,
    preview,
    positionIndex,
    setQuestion,
    overQuestion,
    moveQuestion
  };
}